<a rivLink href="https://www.rivethealth.com/zeliscicustomers" target="_blank">
  <logo [size]="16" [compact]="true"></logo>
  <span> Powered by Rivet</span>
</a>
